import { Component } from 'react';
import { connect } from 'react-redux';
import Bingo from 'modules/Bingo';
import Carousel from 'modules/Carousel';
import Api from 'services/Api';

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export class _CarouselSideEffects extends Component {
  componentDidMount() {
    this.getTickets();
  }

  componentDidUpdate() {
    this.getTickets();
  }

  getTickets = () => {
    const { nextStartDate, activeBottomDesktop, activeBottomMobile, getAssignedTickets } =
      this.props;
    if (
      this.called !== nextStartDate &&
      (activeBottomDesktop === 'select-tickets' || activeBottomMobile === 'select-tickets')
    ) {
      this.called = nextStartDate;
      getAssignedTickets();
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = (state, { refName }) => {
  const assignedRefs = Bingo.selectors.getAssignedTicketRefs(state, refName);
  const nextStartDate = Bingo.selectors.getNextStartDate(state, refName);
  const activeBottomRefsDesktop = Carousel.selectors.getActiveBottomRef(state, 'bingoMiddle');
  const activeBottomRefsMobile = Carousel.selectors.getActiveBottomRef(state, 'bingoMiddleMobile');
  return {
    assignedRefs: assignedRefs,
    nextStartDate: nextStartDate,
    activeBottomDesktop: activeBottomRefsDesktop && activeBottomRefsDesktop,
    activeBottomMobile: activeBottomRefsMobile && activeBottomRefsMobile
  };
};

const mapDispatchToProps = (dispatch, { refName }) => ({
  getAssignedTickets: () => {
    Api.actions.bingo.assignedTickets({ refName: refName, instance: 'next' })(dispatch);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(_CarouselSideEffects);
